import { useT } from "@/i18n";
import { PHOTO_TEXT } from "@/components/photo/content";
import ExposureTriangle from "@/components/photo/ExposureTriangle";
import Framings from "@/components/photo/Framings";
import RuleOfThirds from "@/components/photo/RuleOfThirds";
import { LightTips, WhiteBalance } from "@/components/photo/LightAndWB";
import Cameras from "@/components/photo/Cameras";

export default function PhotoWorkshop() {
  const { lang } = useT();
  return (
    <section className="learn-bg rounded-[2rem] border-4 border-white shadow-xl p-5 sm:p-8 mt-8 space-y-12" data-testid="photo-workshop">
      <div className="flex items-center gap-4">
        <img src="/img/lumi-camera.webp" alt="Lumi con su cámara" className="w-20 sm:w-28 shrink-0 mascot-wiggle lumi-glow" draggable="false" data-testid="photo-lumi-camera" />
        <h2 className="font-fredoka text-2xl sm:text-4xl font-bold bubble-text text-white">{PHOTO_TEXT[lang].title}</h2>
      </div>
      <ExposureTriangle />
      <Framings />
      <RuleOfThirds />
      <LightTips />
      <WhiteBalance />
      <Cameras />
    </section>
  );
}
